import React from "react"
import styled from "styled-components"

const StyledClosingText = styled.div`
  margin-top: 2.4rem;
  line-height: 1.8;
  color: ${props => props.theme.colors.text};

  p + p {
    margin-top: 1em;
  }
`

export default function ClosingText() {
  return (
    <StyledClosingText>
      <p>
        当グループは、お客様との健全な関係を築きながら、社員等の尊厳を守る企業を目指します。
      </p>
      <p>
        お困りごとやお気づきの点がございましたら、誤解を避けるためにも、冷静かつ適切な方法でお申し出いただきますよう、ご理解とご協力をお願いいたします。
      </p>
    </StyledClosingText>
  )
}
